import classnames from 'classnames';
import React from 'react';
import { Link } from 'react-router';
import partial from 'lodash/partial';

import {
  container,
  tileContainer,
  tile,
  tileListItem,
} from './styles.module.css';

import { sectionTitle, sectionListContainer } from '../../styles.module.css';

const TagSearchResults = ({ tags, query, onClick }) =>
  !!tags.length && (
    <div className={container}>
      <span className={sectionTitle}>Browse categories</span>
      <ul className={classnames(sectionListContainer, tileContainer)}>
        {tags.map(({ title, path }) => (
          <li key={path} className={tileListItem}>
            <Link
              to={path}
              className={tile}
              onClick={partial(onClick, { title, path, tags, query })}
            >
              {title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
export default TagSearchResults;
